module.exports = __webpack_public_path__ + "static/img/s165.b2c0f198.png";